import React from 'react';
import { useNavigate } from 'react-router-dom';

function Universe() {
    const navigate = useNavigate(); // Hook to programmatically navigate

    const handleSignupClick = () => {
        navigate('/signup'); // Navigate to the Signup page
    };

    return ( 
        <div className='container mt-5'>
            <div className='row text-center'>
                <h1>The Zerodha Universe</h1>
                <p>Extend your trading and investment experience even further with our partner platforms</p>
               
                <div className='col-4 p-3 mt-5'>
                    <img src='/media/smallcaseLogo.png' style={{width:"100px", height:"100px"}}/>
                    <p className='text-small text-muted'>Thematic investment platform</p>
                </div>
                <div className='col-4 p-3 mt-5'>
                    <img src='/media/streakLogo.png' style={{width:"100px", height:"100px"}}/>
                    <p className='text-small text-muted'>Algo and strategy platform</p>
                </div>
                <div className='col-4 p-3 mt-5'>
                    <img src='/media/sensibullLogo.svg' style={{width:"100px", height:"100px"}}/>
                    <p className='text-small text-muted'>Options trading platform</p>
                </div>
                <div className='col-4 p-3 mt-5'>
                    <img src='/media/zerodhaFundhouse (1).png' style={{width:"150px", height:"150px"}}/>
                    <p className='text-small text-muted'>Asset management</p>
                </div>
                <div className='col-4 p-3 mt-5'>
                    <img src='/media/goldenpiLogo.png' style={{width:"130px", height:"130px"}}/>
                    <p className='text-small text-muted'>Bonds trading platform</p>
                </div>
                <div className='col-4 p-3 mt-5'>
                    <img src='/media/dittoLogo.png' style={{width:"130px", height:"130px"}}/>
                    <p className='text-small text-muted'>Insurance</p>
                </div>
                <button
                    className='p-2 btn btn-primary fs-5 mb-5'
                    style={{ width: "20%", margin: "0 auto" }}
                    onClick={handleSignupClick} // Attach the handleSignupClick function to the button
                >
                    Signup Now
                </button>   
            </div>
        </div>  
    );
}

export default Universe;
